module.exports = __webpack_public_path__ + "img/6-1.0e28f1ea.png";